import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthenticatedResult, OidcSecurityService} from 'angular-auth-oidc-client';
import {combineLatest, Observable, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    isAuthenticated$: Observable<boolean>;
    private unsubscribe$ = new Subject<void>();

    title = 'Campus France - Eclectus';

    constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {
    }

    ngOnInit(): void {
        if (window.location.href.includes('/file/')) {
            localStorage.setItem('file', window.location.href.split('/').slice(-1).pop());
        }
        this.oidcSecurityService.checkAuth()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: ({isAuthenticated}) => {
                    if (isAuthenticated) {
                        if (localStorage.getItem('file')) {
                            this.router.navigate(['/file', localStorage.getItem('file')]);
                        } else if (window.location.pathname === '/' || window.location.pathname.endsWith('/')) {
                            this.router.navigate([{outlets: {primary: 'home'}}]);
                        }
                    } else {
                        if (localStorage.getItem('file')) {
                            this.seConnecter();
                        }
                        this.router.navigate([{outlets: {no: 'home'}}]);
                    }
                },
                error: (err) => {
                    const hasRetried = sessionStorage.getItem('authentErrorRetry') !== null;
                    const errorMsg: string = (err?.message || err?.error?.message || err || '').toString(); // Extraction du message d'erreur de différentes sources possibles
                    if(!hasRetried && errorMsg.startsWith('could not find matching config for state')) {
                        // Cas d'erreur lors d'une redirection vers Eclectus après changement de mdp, on relance l'authent
                        sessionStorage.setItem('authentErrorRetry', 'true'); // On marque qu'on a déjà tenté une fois pour éviter les boucles infinies
                        this.oidcSecurityService.authorize();
                    } else {
                        // Autre cas d'erreur ou l'erreur persiste après retry, on log et redirige vers l'accueil
                        console.error('Authentification error :', err);
                        this.router.navigate([{outlets: {no: 'home'}}]);
                    }
                }
            });

        this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$.pipe(
            map((authenticatedResult: AuthenticatedResult) => authenticatedResult.isAuthenticated)
        );
    }

    logout() {
        sessionStorage.removeItem('authUser');
        console.log('APPEL DU SERVICE logoffAndRevokeTokens');
        this.oidcSecurityService.logoffAndRevokeTokens()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => {
                console.log('data', data);
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.unsubscribe$.unsubscribe();
    }

    seConnecter() {
      this.oidcSecurityService.isAuthenticated().subscribe(isAuthenticated => {
        if(!isAuthenticated) {
          this.oidcSecurityService.authorize();
        }
      });
    }

    inscription() {
      combineLatest([this.oidcSecurityService.getConfiguration(),
        this.oidcSecurityService.isAuthenticated()]).subscribe(([config, isAuthenticated]) => {
          if(!isAuthenticated) {
            this.oidcSecurityService.authorize(config.configId, {customParams: {prompt: 'create'}});
          }
      });
    }
}

